// Text normalization for search (same as RN version)
export const normalizeText = (text: string): string => {
  return text?.toLowerCase()?.trim() || ''
}

// Other text utilities can be added here
export const capitalizeFirstLetter = (text: string): string => {
  if (!text) return ''
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}

export const truncateText = (text: string, maxLength: number): string => {
  if (!text || text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}
